export const LOAD_DETAIL_PATH = 'load';

export const ROUTES = {
  loadBoard: '/find-loads',
  loadDetail: `/${LOAD_DETAIL_PATH}/:loadNumber`,
  myCompany: '/my-company',
  myLoads: '/my-loads',
  myOffers: '/my-offers',
  committedCapacity: '/committed-capacity',
  dedicatedOpportunities: '/dedicated-opportunities',
  profile: '/my-profile',
  notFound: '/not-found',
  authCallback: '/implicit/callback',
  landing: '/',
  contactUs: '/contact-us',
  processOffer: '/process-offer',
  metricSpike: '/chart-demo',
  codedError: '/error',
  suggestedLoads: '/suggested-loads'
}
